import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { DatePicker } from 'components/shadcn/ui/date-picker';
import ViewModeDropdown from './ViewModeDropdown';
import SelectDeviceDropdown from './SelectDeviceDropdown';
import { DeviceTypes } from '../../DeviceDetails/constants';
import { ChartContext } from 'components/HGChart/ChartProvider';
import { useGetIDsFromURL } from 'components/DeviceDetails/helper';
import ChartOptionsMenu from './ChartOptionsMenu';
import Button from 'components/Button';
import {
    ArrowPathIcon,
    MagnifyingGlassMinusIcon,
} from '@heroicons/react/20/solid';

const ChartHeader = () => {
    const {
        deviceType,
        devices,
        selectedDevice,
        setSelectedDevice,
        viewMode,
        setViewMode,
        selectedDate,
        setSelectedDate,
        showResetZoom,
        resetZoom,
        onRefresh,
        statsLoading,
        daysWithData,
        setCalendarViewMonth,
        monthsWithData,
        setCalendarViewYear,
        yearsWithData,
        setCalendarViewPageStart,
    } = useContext(ChartContext);

    const { Thing_ID, BMS_ID, Module_ID } = useGetIDsFromURL();
    const navigate = useNavigate();

    const handleSelectDevice = (device) => {
        if (deviceType === DeviceTypes.Pack) {
            const packSN = typeof device === 'string' ? device.trim() : device?.PACK_SN;
            // Multi-stack: …/:Thing_ID/:BMS_ID/:Module_ID
            // Single-stack: …/:Thing_ID/:BMS_ID (BMS_ID was the old pack SN)
            const path = Module_ID
                ? `/devices/${Thing_ID}/${BMS_ID}/${packSN}`
                : `/devices/${Thing_ID}/${packSN}`;
            navigate(path);
        } else {
            setSelectedDevice(device);
        }
    };

    return (
        <div className="flex flex-col gap-2 sm:flex-row sm:items-end">
            {(deviceType === DeviceTypes.EMS || deviceType === DeviceTypes.Pack) && (
                <SelectDeviceDropdown
                    devices={devices}
                    selectedDevice={selectedDevice}
                    setSelectedDevice={handleSelectDevice}
                    deviceType={deviceType}
                />
            )}
            <div className="flex w-full flex-wrap items-center justify-between gap-2">
                <div className="flex gap-2">
                    <ViewModeDropdown
                        viewMode={viewMode}
                        setViewMode={setViewMode}
                    />
                    <DatePicker
                        selectedDate={selectedDate}
                        setSelectedDate={setSelectedDate}
                        view={viewMode}
                        disableFuture
                        daysWithData={daysWithData}
                        onViewMonthChange={setCalendarViewMonth}
                        monthsWithData={monthsWithData}
                        onViewYearChange={setCalendarViewYear}
                        yearsWithData={yearsWithData}
                        onViewPageChange={setCalendarViewPageStart}
                    />
                </div>
                <div className="flex gap-2">
                    {/* Reset Zoom */}
                    <Button
                        onClick={resetZoom}
                        disabled={!showResetZoom}
                        size="icon"
                    >
                        <MagnifyingGlassMinusIcon className="h-4 w-4" />
                    </Button>
                    {/* Refresh */}
                    <Button
                        onClick={onRefresh}
                        disabled={statsLoading}
                        size="icon"
                    >
                        <ArrowPathIcon className="h-4 w-4" />
                    </Button>
                    {/* Chart Type, Show Lines, Raw Data */}
                    <ChartOptionsMenu />
                </div>
            </div>
        </div>
    );
};

export default ChartHeader;
